import { IconButton, iconSizes, Menu, Text } from '@common/ui'
import { IconDotsVertical } from '@common/ui/icons'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/web'
import { useFetchEntity } from '../../io/useEntities'
import EntityWithLabelAndRelated from '../../domain/entity/EntityWithLabelAndRelated'
import EntityId = com.eidu.entity.EntityId

type ActionsMenuProps = {
  userEntityId: EntityId | undefined
  signOut?: () => void
}

const ActionsMenu = ({ userEntityId, signOut }: ActionsMenuProps) => {
  const navigate = useNavigate()
  const fetchEntity = useFetchEntity()

  const [userEntity, setUserEntity] = useState<EntityWithLabelAndRelated>()

  useEffect(() => {
    if (userEntityId)
      fetchEntity(userEntityId).then((entity) => {
        if (entity !== null) setUserEntity(entity)
      })
  }, [userEntityId, fetchEntity])

  const openCurrentUser = () => {
    if (!userEntity) return
    navigate(`/entities/${userEntity.entity.typeId.toString()}/view/${userEntity.entity.id.toString()}`)
  }

  if (!userEntity && !signOut) return null

  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <IconButton aria-label="Open user actions menu" size="lg" c="var(--trellis-color-on-accent)">
          <IconDotsVertical size={iconSizes.sm} stroke={1.5} />
        </IconButton>
      </Menu.Target>
      <Menu.Dropdown>
        {userEntity && (
          <Menu.Item onClick={openCurrentUser}>
            <Text size="sm">Your Profile</Text>
            <Text size="xs" c="dimmed" data-testid="user-profile-secondary">
              {userEntity.primaryLabelText || userEntity.entity.id.toString()}
            </Text>
          </Menu.Item>
        )}
        {userEntity && signOut && <Menu.Divider />}
        {signOut && <Menu.Item onClick={signOut}>Log out</Menu.Item>}
      </Menu.Dropdown>
    </Menu>
  )
}

export default ActionsMenu
